import { render, staticRenderFns } from "./CampaignCreate.vue?vue&type=template&id=981258b8&"
import script from "./CampaignCreate.vue?vue&type=script&lang=js&"
export * from "./CampaignCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports